import { Modal } from 'antd'
import AutoComplete from 'react-google-autocomplete'
import { LocationType } from './searchPage'
import { Done } from '@mui/icons-material'

const LocationModal = ({
  setLocation,
  setIsLocationModalOpen,
}: {
  setLocation: (location: LocationType) => void
  setIsLocationModalOpen: (value: boolean) => void
}) => {
  return (
    <Modal centered open onClose={() => setIsLocationModalOpen(false)} footer={[]}>
      <div className="flex flex-col items-center">
        <AutoComplete
          className="text-input"
          apiKey={process.env.REACT_APP_MAPS_API_KEY}
          onPlaceSelected={(place) => {
            setLocation({
              type: 'Point',
              coordinates: [place.geometry.location.lng(), place.geometry.location.lat()],
            })
          }}
          options={{
            types: ['(regions)'],
            componentRestrictions: { country: ['us', 'ps', 'il'] },
          }}
        />
        <button
          className="flex p-0 mt-2.5 justify-center items-center size-12 rounded-full bg-[#8830C7]"
          onClick={() => setIsLocationModalOpen(false)}
        >
          <Done />
        </button>
      </div>
    </Modal>
  )
}

export default LocationModal
